import React from "react";
import { FormattedMessage } from "react-intl";
import coverImage from "../../../../assets/images/misc/course-cover.webp";
import { getLanguageName } from "../../../../utils/languageUtils";
import { Button } from "../../../button/Button";
import { Background } from "../../layout/Background";
import styles from "./CourseIntroCard.scss";

const msgKey = "courseIntroCard";

/**
 * First card of a course: cover image with language, title, description and number of questions
 * @param onStart – shows a "Start course" button that calls it (leave out e.g. while editing)
 */
export const CourseIntroCard = ({ course, numberOfQuestions, onStart }) => {
    return (
        <div className={styles.base}>
            <div className={styles.text}>
                {course.language ? <span className={styles.language}>{getLanguageName(course.language)}</span> : null}
                <h1 className={styles.title} lang={course.language || "en"}>
                    {course.title}
                </h1>
                {course.description ? <p className={styles.description}>{course.description}</p> : null}
                {numberOfQuestions > 0 && (
                    <p className={styles.questionCount}>
                        <FormattedMessage id={`${msgKey}.questionCount`} values={{ count: numberOfQuestions }} />
                    </p>
                )}
                {onStart ? (
                    <Button
                        color="primary"
                        size="big"
                        icon="arrow-right"
                        iconRight
                        onClick={onStart}
                        className={styles.start}
                    >
                        <FormattedMessage id={`${msgKey}.startCourse`} />
                    </Button>
                ) : null}
            </div>
            <Background imageUrl={course.cover?.url || coverImage} />
        </div>
    );
};
